import { render } from "./NewMessageNewFileDialog.vue?vue&type=template&id=c8def1c6&scoped=true"
import script from "./NewMessageNewFileDialog.vue?vue&type=script&lang=js"
export * from "./NewMessageNewFileDialog.vue?vue&type=script&lang=js"

import "./NewMessageNewFileDialog.vue?vue&type=style&index=0&id=c8def1c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8def1c6"]])

export default __exports__